app.controller("LecturerTableController", ["$scope", "Users", "Session", "StaticData", "AuthService", 'usSpinnerService',
    function ($scope, Users, Session, StaticData, AuthService, usSpinnerService) {
        var lecturer;
        var season;

        AuthService.getUserData().then(function (data) {
            lecturer = _.find(data.profiles, {state: 'active', type: 'lecturer'});
            StaticData.getSystemParam("currentSeason").then(function (data) {
                season = data;
                load();
            });
        });

        StaticData.getItemsByKey("session_types").then(function (sessionTypes) {
            $scope.sessionTypes = sessionTypes;
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = buildings;
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        function load() {
            usSpinnerService.spin("root");
            Session.lecturerTableByLecturer({
                lecturer: lecturer._id,
                season: season,
            }).then(function (data) {
                $scope.sessionsByDays = _.groupBy(data, 'dayOfWeek');
                $scope.totalItems = data.length;
                usSpinnerService.stop("root");
            })
        }
    }
]);
